import { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/* ─── Top Strip Banner (subtle text bar for authenticated users) ─── */
export function PromoBanner() {
  const [promotions, setPromotions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/promotions/active`);
        if (res.data && res.data.length > 0) {
          setPromotions(res.data);
        }
      } catch {
        // silently fail
      }
    };
    fetchPromos();
    const interval = setInterval(fetchPromos, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (promotions.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % promotions.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [promotions.length]);

  if (promotions.length === 0 || dismissed) return null;

  const promo = promotions[current];
  const hasMultiple = promotions.length > 1;

  return (
    <div
      className="w-full flex items-center justify-between px-4 md:px-6 py-2 text-sm shrink-0"
      style={{ background: "linear-gradient(90deg, #4338ca 0%, #6366f1 50%, #4338ca 100%)" }}
      data-testid="promo-top-strip"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {hasMultiple && (
          <div className="flex items-center gap-1 shrink-0">
            <button
              onClick={() => setCurrent((c) => (c - 1 + promotions.length) % promotions.length)}
              className="w-6 h-6 rounded-full flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10 transition-colors"
              data-testid="promo-strip-prev"
            >
              <ChevronLeft className="w-3.5 h-3.5" />
            </button>
            <span className="text-[10px] text-white/40 font-mono">{current + 1}/{promotions.length}</span>
            <button
              onClick={() => setCurrent((c) => (c + 1) % promotions.length)}
              className="w-6 h-6 rounded-full flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10 transition-colors"
              data-testid="promo-strip-next"
            >
              <ChevronRight className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <span className="font-semibold text-white shrink-0 text-xs sm:text-sm">{promo.title}</span>
          {promo.description && (
            <span className="text-white/70 truncate hidden sm:inline text-xs">{promo.description}</span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0 ml-3">
        {promo.link_url && (
          <a
            href={promo.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-white/90 font-medium hover:text-white hover:underline whitespace-nowrap text-xs sm:text-sm"
            data-testid="promo-strip-link"
          >
            {promo.link_text || "Saiba mais"}
            <ExternalLink className="w-3 h-3" />
          </a>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="w-5 h-5 rounded-full flex items-center justify-center text-white/40 hover:text-white hover:bg-white/10 transition-colors"
          data-testid="promo-strip-close"
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
